module.exports = __webpack_public_path__ + "media/images/landing/en/main-7c8a6bba9e5d0fb365a34e6dfafb61a1.png";